







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'action-button'
})
export default class ActionButton extends Vue
{
    @Prop() private toolbar: boolean;
    @Prop() private submit: boolean;
    @Prop() private to: Record<string, any>;
    @Prop() private back: boolean;
    @Prop() private icon: string;
    @Prop() private text: string;
    @Prop({default: 'primary'}) private variant: string;

    private dropdown = false;
    private floating = false;

    private get condition(): boolean
    {
        if ((this.$parent as any).condition !== undefined)
            return (this.$parent as any).condition;
        else
            return this.mobile;
    }

    private get standardButton()
    {
        return !this.condition;
    }

    private get backButton()
    {
        return this.condition && (this.back !== undefined && this.back !== false) && !this.dropdownButton && !this.floatingButton;
    }

    private get dropdownButton()
    {
        return this.condition && this.dropdown;
    }

    private get floatingButton()
    {
        return this.condition && this.floating;
    }

    private get buttonType(): string
    {
        return this.submit !== undefined && this.submit !== false ? 'submit' : 'button';
    }

    private get buttonClass()
    {
        if (this.dropdownButton)
            return 'dropdown-item';

        if (this.floatingButton)
            return `btn btn-${this.variant} btn-float rounded-pill`;

        if (this.backButton)
            return 'btn btn-light bg-white border-0 px-1';

        return `btn btn-${this.variant}`;
    }

    private get iconClass()
    {
        if (this.dropdownButton)
            return `${this.icon} ${this.iconSpace}`;

        if (this.floatingButton)
            return `${this.icon} fa-fw`;

        if (this.backButton)
            return `fas fa-arrow-left fa-back`;

        return `${this.icon} ${this.iconSpace}`;
    }

    private get iconSpace()
    {
        return this.textVisible ? 'mr-2' : '';
    }

    private get textVisible()
    {
        if (!this.text)
            return false;

        if (this.dropdownButton)
            return true;

        if (this.floatingButton)
            return false;

        if (this.backButton)
            return false;

        return true;
    }

    mounted()
    {
        this.dropdown = this.$el.parentElement.classList.contains('dropdown-menu');
        this.floating = this.$el.parentElement.classList.contains('floating');
    }

    onClick(e: any)
    {
        if (this.to)
        {
            this.redirect(this.to);
        }
        else
        {
            this.$emit('click', e);
        }
    }
}
